module.exports = __webpack_public_path__ + "media/dog-personality-traits/rope-31b0932a.svg";